import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit"
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist"
import storage from "redux-persist/lib/storage" // defaults to localStorage for web
import reducer from "./reducer"

import { idmsApi, everestApi } from "../services/api"

const persistConfig = {
  key: "root",
  // version: 1,
  storage,
  whitelist: ["auth", "grid"],
}

export const store = configureStore({
  reducer: persistReducer(persistConfig, reducer),

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(idmsApi.middleware, everestApi.middleware), // Add the middleware to the store to enable caching, polling, invalidation.
})

export const persistor = persistStore(store)

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
